module.exports = __webpack_public_path__ + "static/media/Kai.5113074f.png";